import React, { Component, useState, useEffect } from 'react';
import Select from 'react-select';
import * as ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import { debug } from 'util';
import axios from 'axios';
import Configdata from './Defaultdata';
import './home.css';
import Localdata from './Localdata';
import './cube.css';
import { arutyps,arutypsa,arutypso,citiescodes } from './userdefaultdata';
import { getmessage,wrongmsg,clearform,displayprofile } from './Dynamictable';
import Register from './Register';
import {txtnullchk,isvaluenull,isvalidatemail,isvalidmob} from './validation';
import Usersession from './Usersession';
export default class Signup extends Component {

    constructor(props: any) {
   	super(props);
	this.state.name = "siikaa";
	
  	}
	
    state = {

	
	usertyeopt:0,
	citycode:'',

        name: "",
        type: "1",
        phone: "",
	email:"",
        msg: "",
	passwrd:"",
        typeoption: null,
        respdata: null,
	usercode: '',
        isVisible: true,
        resm: null,
        url: "",
	usertps: [{ value: 7, label: 'General' }],
        citycods: [{ value: 'DEL', label: 'Delhi' }]	
       
    };
    pagetextboxChange(event: any) {
         const id = event.target.id;
	const elvalue = event.target.value;
	
        if(id == 'txtusername'){
        
	 this.setState({ name: elvalue });
	}
	else if(id == 'txtemailid'){
	 this.setState({ email: elvalue });
	}
	else if(id == 'txtphno'){
	 this.setState({ phone: elvalue });
	}
	else if(id == 'txtposword'){
	 this.setState({ passwrd: elvalue });
	}
	
   }
   isvalidatedctrls(){
	let isvalidate = true;
	
	if(isvaluenull(this.state.name)){
	  getmessage('Name should not Blanck','');
	  return false;
	}
	else if(this.state.usertyeopt == 0){
	 getmessage('Please select user type','');
	  return false;

	}
	else if(isvaluenull(this.state.citycode)){
	 getmessage('Please select city','');
	  return false;

	}	
	else if(!isvalidmob(this.state.phone)){
	 getmessage('Not a valid phone no','');
	  return false;

	}	
	else if(!isvalidatemail(this.state.email)){
		 getmessage('Please enter a valid mail Id','');
	  return false;
	}
	else if(isvaluenull(this.state.phone)){
	  getmessage('Phone No should not Blanck','');
	  return false;
	}
	else if(isvaluenull(this.state.passwrd)){
	  getmessage('Password should not Blanck','');
	  return false;
	}
	else if(isvaluenull(this.state.email)){
	  getmessage('Email should not Blanck','');
	  return false;
	}
	else if(this.state.passwrd.length < 8 || this.state.passwrd.length > 12 ){
	  getmessage('Password length between 8 to 12 charectors','');
	  return false;
	}
	
	return isvalidate;	
    }	
    
    utypeChange(event: any) {

        const typevalue = event.value;
       
        this.setState({ usertyeopt: typevalue });
	
    }
    cityChange(event: any) {

        const typevalue = event.value;
       
        this.setState({ citycode: typevalue });
     }
	
    Homehitcount() {
              
        try {
          
            //const promiseAwait = fetch(Configdata.srvurl + '/Hitcountinput');
          }
        catch (e) {
            debugger;


        }
    }
  
    setserverurl() {
        debugger;
        const appurl = Configdata.srvurl;
       
        this.setState({ url: appurl });
    }
    componentDidMount() {
        debugger;
     
        
        this.setserverurl();
        const guestmail = Usersession.getGuestmailid(); 
	if(guestmail == 'SuperAdmin@SIIKAA.in') this.setState({ usertps: arutypsa });
	else if(guestmail == 'OFFICIALuser@SIIKAA.in') this.setState({ usertps: arutypso });
	else this.setState({ usertps: arutyps });
	
	this.setState({ citycods: citiescodes });


    }
    typeselect(e: any){
		
		
		const eid = e.target.id;
		e.target.style.backgroundColor = 'green';
		
		e.preventDefault()

     };
     insertusersignup(e: any){
	 try {
		if(this.isvalidatedctrls()){
		getmessage('On Process Please wait.....','');
          	const ctcod = this.state.citycode;
               // alert(ctcod);
		const emlid = this.state.email;
		const uphn = this.state.phone;
            	//alert(this.state.usertyeopt);	

                const response = axios.post(Configdata.srvurl + '/insertuser', {
    		uname: this.state.name,
    		utypeid: this.state.usertyeopt,
    		uemail: emlid,
                uphone: uphn,
		citcod: ctcod,
		upass:this.state.passwrd
		
  		}, {
    		    headers: {
      				'Content-Type': 'application/json'
    			      }
  			}
		);
	      
                if(response){
		 response.then((result:any) => {
		 
		const usercd = result.data;
		const uniqcode = 'User id is :  ' + usercd;
		getmessage(uniqcode,'Login and post');
		// this.setState({ usercode: usercd });
                const clr = clearform('frmsignup');
		this.clearadminusermailid();
		displayprofile();
	        });		
              }
		
	   }
          }
        catch (e) {
           // debugger;
		wrongmsg();
        }

	
      	e.preventDefault()


     }	

     clearadminusermailid(){

	const adminmail = Usersession.getGuestmailid();
        if(adminmail == 'SuperAdmin@SIIKAA.in' || adminmail == 'OFFICIALuser@SIIKAA.in') 
		Usersession.setGuestmailid('user');
     }	

    
 render() {

   
     return (

         <form id="frmsignup">
	<div className="per100" id="postmain">
	 <div className="postingouterdiv" style={{overflowX:'hidden',overflowY:'auto',height:'93vh'}}>
	  <div className="postingtablediv">

	    <table className="postingtable">
		

		<tr>
		<td>
			<div className="postingrowdiv">
			<input type="text" placeholder="Enter name" onChange={e => this.pagetextboxChange(e)} id="txtusername" className="postingtxtbox" />
			</div>
		</td>
		</tr>
		<tr>
		<td>
			<div className="postingrowdropdown">
    <Select placeholder="Select tytpe"  onChange={e => this.utypeChange(e) } id="utyp" options={this.state.usertps} className="postingtxtbox" />

			</div>
		</td>
		</tr>
		<tr>
		<td>
			<div className="postingrowdropdown">
    <Select placeholder="Select City"  onChange={e => this.cityChange(e) } id="ucity" options={this.state.citycods} className="postingtxtbox" />

			</div>
		</td>
		</tr>

		<tr>
		<td>
			<div className="postingrowdiv">
		<input type="email" onChange={e => this.pagetextboxChange(e)} placeholder="Enter Email Id" id="txtemailid" className="postingtxtbox" />
			</div>
		</td>
		</tr>
		<tr>
		<td>
			<div className="postingrowdiv">
		<input type="text" placeholder="Enter Phone No." id="txtphno" onChange={e => this.pagetextboxChange(e)} className="postingtxtbox" />
			</div>
		</td>
		</tr>
		<tr>
		<td>
			<div className="postingrowdiv">
		<input type="text" placeholder="Enter Password" onChange={e => this.pagetextboxChange(e)} id="txtposword" className="postingtxtbox" />
			</div>
		</td>
		</tr>
		<tr>
		<td>
			<div className="postingrowdiv">
				
				  
				    <a href="#" onClick={e => this.insertusersignup(e)} title="Partner">

					<div className="searchtype" id="btnsingup" style={{backgroundColor:'gray',marginLeft:'0px',float:'right'}}>
			  			SignUp	
					</div>
				    </a>
		     		

			</div>
			
		</td>
		</tr>
		

	   </table>
	 </div>		
	</div>
	
	</div>
   	</form>
    
   
      );
}
}

